import React, { useEffect, useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";

function BeelditPasswordInput(props: any) {
  const {
    id,
    value,
    required,
    disabled,
    readonly,
    onChange,
    placeholder,
  } = props;

  const [inputValue, setInputValue] = useState(value ?? "");
  const [reveal, setReveal] = useState(false);

  // Sin debounce: actualiza inmediatamente el valor hacia arriba
  useEffect(() => {
    onChange(inputValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);

  useEffect(() => {
    setInputValue(value ?? "");
  }, [value]);

  return (
    <div className="input-group">
      <input
        id={id}
        className="form-control"
        type={reveal ? "text" : "password"}
        value={inputValue ?? ""}
        required={required}
        disabled={disabled}
        readOnly={readonly}
        placeholder={placeholder}
  onChange={(e) => setInputValue(e.target.value)}
      />
      <button
        type="button"
        className="btn btn-outline-secondary"
        onClick={() => setReveal((v) => !v)}
        tabIndex={-1}
        aria-label="Mostrar u ocultar contraseña"
        title={reveal ? "Ocultar" : "Mostrar"}
      >
        {reveal ? <EyeSlash size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}

export default BeelditPasswordInput;
